const STORAGE_PREFIX = 'admin-accruals-im-column-mapping';

export function getImColumnMappingStorageKey(projectId) {
  return `${STORAGE_PREFIX}-${projectId}`;
}

export function loadImColumnMapping(projectId) {
  if (!projectId) return null;
  try {
    const raw = window.localStorage.getItem(getImColumnMappingStorageKey(projectId));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
}

export function saveImColumnMapping(projectId, mapping) {
  if (!projectId || !mapping) return;
  window.localStorage.setItem(
    getImColumnMappingStorageKey(projectId),
    JSON.stringify(mapping),
  );
}
